import React from 'react'
import {
    Archive,
    Copy,
    List,
    Minus,
    PageEdit,
    Plus,
    ShareAndroid,
    Trash,
} from 'iconoir-react'

const MobileOption = ({
    setShowMobileOptions,
    rowId,
    handleModalDelete,
    historyPush,
    historyPushCopy,
    historyPushConsulting,
    handleModalShare,
    setStyleId,
    view,
    historyPushUpdate,
    isSeriesRun,
    handleModalAddToSeries,
    handleModalArchived,
    isArchivedSeries,
    isPartnerRun,
}) => {
    return (
        <div className="h-42 fixed  bottom-0 left-0 right-0 z-50 w-full bg-white text-lg text-gray-800 shadow-mobile">
            <i
                className="fas fa-times absolute right-0 cursor-pointer px-2 pt-2"
                onClick={(e) => {
                    e.stopPropagation()
                    setShowMobileOptions(false)
                    setStyleId(null)
                }}
            />
            <div className="flex flex-col justify-between px-6 py-2 ">
                {handleModalShare ? (
                    <div
                        className="flex w-full cursor-pointer items-center justify-between border-b border-gray-500 py-4"
                        onClick={(e) => {
                            e.stopPropagation()
                            handleModalShare(rowId)
                        }}
                    >
                        <ShareAndroid />
                        <div className="mx-auto">
                            {isPartnerRun ? 'Retirer le partage' : 'Partager'}
                        </div>
                    </div>
                ) : null}
                {historyPushCopy ? (
                    <div
                        className={`flex w-full cursor-pointer items-center  justify-between border-b border-gray-500 py-4 `}
                        onClick={(e) => {
                            e.stopPropagation()
                            historyPushCopy(rowId)
                        }}
                    >
                        <Copy />
                        <div className="mx-auto">Copier</div>
                    </div>
                ) : null}
                {historyPushConsulting ? (
                    <div
                        className="flex w-full cursor-pointer  items-center justify-between border-b border-gray-500 py-4"
                        onClick={(e) => {
                            e.stopPropagation()
                            historyPushConsulting(rowId)
                        }}
                    >
                        <List />
                        <div className="mx-auto">Consulter</div>
                    </div>
                ) : null}
                {historyPush ? (
                    <div
                        className="flex w-full cursor-pointer  items-center justify-between border-b border-gray-500 py-4"
                        onClick={(e) => {
                            e.stopPropagation()
                            historyPushUpdate(rowId)
                        }}
                    >
                        <PageEdit />
                        <div className="mx-auto">Modifier</div>
                    </div>
                ) : null}
                {handleModalArchived ? (
                    <div
                        className="flex w-full cursor-pointer  items-center justify-between border-b border-gray-500 py-4"
                        onClick={(e) => {
                            e.stopPropagation()
                            handleModalArchived(rowId)
                        }}
                    >
                        <Archive />
                        <div className="mx-auto">
                            {isArchivedSeries ? 'Désarchiver' : 'Archiver'}
                        </div>
                    </div>
                ) : null}

                {handleModalAddToSeries ? (
                    <div
                        className="flex w-full cursor-pointer  items-center justify-between border-b border-gray-500 py-4"
                        onClick={(e) => {
                            e.stopPropagation()
                            handleModalAddToSeries(rowId)
                        }}
                    >
                        {isSeriesRun ? <Minus /> : <Plus />}
                        <div className="mx-auto">Série</div>
                    </div>
                ) : null}
                {handleModalDelete ? (
                    <div
                        className="flex  w-full cursor-pointer items-center  py-4 text-red-600"
                        onClick={(e) => {
                            e.stopPropagation()
                            handleModalDelete(rowId)
                        }}
                    >
                        <Trash />
                        <div className="mx-auto">Supprimer</div>
                    </div>
                ) : null}
            </div>
        </div>
    )
}

export default MobileOption
